import React, { useState, useEffect, useMemo } from "react";
import Base from "../../Config/Base";
import { API_BASE_CRM_URL, API_BASE_URL } from "../../Config/Config";
import Pagination from "../../Config/Pagination";
import "../../../Assets/popup.css";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "../../Config/loading.css";
import { Link, useNavigate } from "react-router-dom";
import { useLabelContext } from "../../../Context";
import { Footer } from "../footer/footer";

export default function Refund() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [refundData, setRefundData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [userDataSession, setUserDataSession] = useState({});
  const { setID } = useLabelContext();

  useEffect(() => {
    const userDataString =
      sessionStorage.getItem("MisUserDetails") ||
      localStorage.getItem("MisUserDetails");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  console.log(userDataSession);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}Billing/getReFundOrders?OrgId=${userDataSession.OrgId}`
        );
        const data = await response.json();
        console.log(data);
        if (data.Status) {
          setRefundData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setRefundData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    if (userDataSession && userDataSession.OrgId) {
      fetchData();
    }
  }, [userDataSession.OrgId]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const filteredItems = useMemo(() => {
    const results = refundData.filter(
      (item) =>
        item.OrderNO &&
        item.OrderNO.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setCurrentPage(1);
    return results;
  }, [refundData, searchTerm]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  return (
    <Base>
      <div className="page-header">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="page-title me-3">
            <h4>Refund</h4>
            <h6>Manage your Refunds</h6>
          </div>
          <div className="search-bar mb-3 ">
            <div className="input-group">
              <input
                type="text"
                name="search..........."
                placeholder="Search..."
                className="form-control"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="card-container mb-0" style={{ marginTop: "-20px" }}>
        {loading ? (
          <div className="text-center my-5">
            <div className="containers m-auto d-flex justify-content-center align-items-center">
              <div className="dot bg-primary"></div>
              <div className="dot bg-secondary"></div>
              <div className="dot bg-success"></div>
              <div className="dot bg-danger"></div>
              <div className="dot bg-warning"></div>
              <div className="dot bg-info"></div>
            </div>
            <p>Loading...</p>
          </div>
        ) : (
          <div className="row">
            {currentItems &&
              currentItems.map((item, index) => (
                <div
                  key={index}
                  className="col-md-6"
                  style={{ marginTop: "-20px" }}
                >
                  <div
                    className="supplier-card card shadow-sm my-3"
                    style={{ border: "1px solid #ddd", borderRadius: "8px" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title d-flex align-items-center mb-3"
                        style={{ color: "#007bff" }}
                      >
                        <i
                          className="fa-solid fa-person-biking "
                          style={{ marginRight: "2px", color: "#007bff" }}
                        ></i>{" "}
                        {item.OrderNO}
                      </h5>
                      <div className="card-details">
                        <div
                          className="row"
                          style={{ color: "#6c757d", marginTop: "10px" }}
                        >
                          <div className="col-7">
                            <span>
                              <i
                                className="fa-solid fa-user me-2"
                                style={{ color: "#007bff" }}
                              ></i>
                              {item.Total}
                            </span>
                          </div>
                          <div className="col-5">
                            <span>
                              <strong>
                                <i
                                  class="fa-solid fa-phone"
                                  style={{ color: "#007bff" }}
                                ></i>
                              </strong>{" "}
                              {formatDate(item.OrderDate)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        )}
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={refundData.length}
          paginate={paginate}
          currentPage={currentPage}
        />
      </div>
      <br />
      <br />
      <br />

      <Footer></Footer>
    </Base>
  );
}
